import axios from 'axios';

function buildFormData(param) {
  const fd = new FormData();
  for (const item in param) {
    fd.append(item, param[item]);
  }
  return fd;
}

function authHeaders() {
  return {
    auth: `${localStorage.getItem('api_key') ? localStorage.getItem('api_key') : null}`,
    'Content-Type': 'application/x-www-form-urlencoded',
  };
}

function post(url, param) {
  return new Promise(function (resolve, reject) {
    axios
      .post(url, buildFormData(param), { headers: authHeaders() })
      .then((response) => {
        if (response) {
          resolve(response.data ? response.data : null);
        }
      })
      .catch(function (error) {
        reject({ status: 1, errorText: error });
      });
  });
}

export function sendRequest(url, param) {
  return post(window.url + url, param);
}

export function sendRequestAuth(url, param) {
  return new Promise(function (resolve, reject) {
    post(window.url2 + url, param)
      .then((data) => {
        if (data && data.auth) {
          resolve(null);
        } else {
          resolve(data);
        }
      })
      .catch(function (error) {
        reject({ status: 1, errorText: error });
      });
  });
}
